// assets/quick-add.js
document.addEventListener("DOMContentLoaded", function () {
  // Delegate submit handling for all quick-add forms
  document.body.addEventListener("submit", function (event) {
    var form = event.target;

    if (!form.classList.contains("product-grid__quick-add")) return;

    event.preventDefault();

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn && submitBtn.disabled) return;

    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.originalText = submitBtn.textContent;
      submitBtn.textContent = "Adding…";
    }

    var formData = new FormData(form);

    fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
      },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then(function (data) {
        // data.product is the added product
        updateCartCount();
        showQuickAddNotification(data);
      })
      .catch(function (error) {
        console.error("Quick add error:", error);
        showQuickAddNotification(null, true);
      })
      .finally(function () {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.originalText || "Buy Now";
        }
      });
  });

  function updateCartCount() {
    fetch("/cart.js", {
      headers: {
        Accept: "application/json",
      },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Cart fetch failed");
        return response.json();
      })
      .then(function (cart) {
        var countEl = document.querySelector("[data-cart-count]");
        if (countEl) {
          countEl.textContent = cart.item_count;
        }
      })
      .catch(function (error) {
        console.error("Cart count update error:", error);
      });
  }

  function showQuickAddNotification(data, isError) {
    var existing = document.getElementById("QuickAddNotification");
    if (!existing) {
      existing = document.createElement("div");
      existing.id = "QuickAddNotification";
      existing.className = "quick-add-notification";
      document.body.appendChild(existing);
    }

    if (isError) {
      existing.textContent = "Sorry, something went wrong adding to cart.";
    } else if (data && data.product && data.product.title) {
      existing.textContent = '"' + data.product.title + '" added to your cart.';
    } else {
      existing.textContent = "Added to your cart.";
    }

    existing.classList.add("is-visible");

    setTimeout(function () {
      existing.classList.remove("is-visible");
    }, 3000);
  }
});